import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Normalize a Kuwaiti phone typed/autofilled into an input that already
 * shows a fixed +965 prefix. Autofill bypasses maxLength and inserts the
 * full international number (e.g. "+965 9967 3276" or "0096599673276"),
 * which would otherwise get +965 prepended twice. Returns local digits only,
 * capped at 8.
 */
export function normalizeKuwaitPhoneInput(raw: string): string {
  let digits = raw.replace(/\D/g, "");
  if (digits.startsWith("00")) digits = digits.slice(2);
  while (digits.length > 8 && digits.startsWith("965")) digits = digits.slice(3);
  return digits.slice(0, 8);
}
